<template>
  <div>
    <component v-if="currentView!='' && captcha!='' & WebCode!=''" :webname="captcha.webname" :WebCode="WebCode" :is="currentView" :key="currentView" :captcha="captcha" @switchWindow="switchWindow" v-loading="loading" ></component>
    <div v-else>
        <div style="width:100%;display: flex;justify-content: center;padding-top: 100px;" v-if="shocodes">
              <input v-model="selectcode"/>
              <button @click="codeselect()">确认</button>
        </div>
        <div v-else>
          <div v-if="showerro" class="showerro_box"  v-loading="loading">网络连接失败,请稍后重试或点击重新加载<el-icon><Refresh /></el-icon></div>
          <div v-else class="showerro_box"  v-loading="loading"><el-icon><Loading /></el-icon>加载中……</div>          
        </div>

    </div>    
  </div>

  
</template>

<script>
import { defineAsyncComponent } from 'vue';
export default {
  data() {
    return {
      loading:true,
      currentView: '',
      captcha:'',
      showerro:false,
      clientWidth: document.documentElement.clientWidth, 
      zoomValue:1,
      WebCode:'',
      shocodes:false,
      selectcode:''
    }
  },
  created() {

    const protocol = window.location.protocol;
    const host = window.location.host;
    const currentUrl = `${protocol}//${host}`; 
    this.$request.setBaseURL(currentUrl )

  },
  components: {
    login1: defineAsyncComponent(() => import('./views/style1/login/login.vue')),
    home1: defineAsyncComponent(() => import('./views/style1/home/home.vue')),
    modifypasswor1: defineAsyncComponent(() => import('./views/style1/login/modifypasswor.vue')),
  },
  mounted() {
    const params = new URLSearchParams(window.location.search); 
    const param1 = params.get('code'); 
    if(!param1 || param1==''){
      this.loading=false
      this.shocodes=true
      this.showerro=true
      return
    }
    this.WebCode=param1
    this.getstyle()
    this.bodyScale() 
    window.addEventListener('resize', () => { 
            this.clientWidth = document.documentElement.clientWidth 
            this.bodyScale() 
        
        }) 

    // window.addEventListener("resize", this.bodyScale, false);
  },
  methods: {
    bodyScale() {
        // var deviceWidth = document.documentElement.clientWidth; //获取当前分辨率下的可是区域宽度
        // var scale = deviceWidth / 1600; // 分母——设计稿的尺寸
        // document.documentElement.style.zoom = scale; //放大缩小相应倍数
            const baseSize = 1600 
            if (this.clientWidth < 1900) { 
                this.zoomValue = (this.clientWidth / baseSize).toFixed(2) 
            } else { 
                this.zoomValue = 1 
            } 
             document.body.style.zoom = this.zoomValue //echarts 
            // // 处理缩放导致canvas定位异常 
            document.styleSheets[document.styleSheets.length - 1].insertRule('canvas {zoom: ' + 1 / this.zoomValue + '}') 
            document.styleSheets[document.styleSheets.length - 1].insertRule( 'canvas {transform: scale(' + this.zoomValue + ')}' ) 
            document.styleSheets[document.styleSheets.length - 1].insertRule('canvas {transform-origin: 0 0}')       
            

    },  
    switchWindow(view) {
      this.currentView = view; // 设置当前显示的组件名称
    },
    getstyle(){
        this.loading=true
        this.$request.postData('/getcaptcha',{'WebCode':this.WebCode}).then(response => {
          if(response.code==200){
            this.showerro=false
            this.captcha=response.data
            var value = response.data.color
            this.$store.commit('setValue',value)
            import(`@/assets/style${value}/home.css`)
            this.currentView = 'login' + value  
          }else{
            this.$message.error(response.msg);
          }
           this.loading=false
        }).catch(error => {
            this.showerro=true
            this.loading=false
            this.$message.error('网络错误，请稍后重试~');
        });        
    },
    codeselect(){
      if(this.selectcode!=''){
          const protocol = window.location.protocol;
          const host = window.location.host;
          const currentUrl = `${protocol}//${host}/?code=${this.selectcode}`;   
          window.location.href=currentUrl
      }    
    }
  }

}
</script>
<style>
body{
  position: relative  !important; 
}
</style>

